// Translations for DB-driven labels (SubCategories.Name, Keywords.Name, Categories.Name).
// These arrive from the API as raw English; the ContentTranslations system only covers
// video/blog content fields, so this small fixed label set is mapped client-side instead.
// Lookup is trim + case-insensitive ("Lower body" and "Lower Body" both exist in the DB);
// unknown values fall back to the raw English name.

const FR = {
  "eating habits": "Habitudes alimentaires",
  "blood-pressure": "Tension artérielle",
  "blood-sugar": "Glycémie",
  "brain health": "Santé du cerveau",
  "breathwork": "Respiration",
  "core stability": "Stabilité du tronc",
  "digestive system": "Système digestif",
  "food intolerance": "Intolérance alimentaire",
  "habits": "Habitudes",
  "lower body": "Bas du corps",
  "macro nutrients": "Macronutriments",
  "micro nutrients": "Micronutriments",
  "sleep": "Sommeil",
  "stress management": "Gestion du stress",
  "upper body": "Haut du corps",
  "abdominals": "Abdominaux",
  "ankle": "Cheville",
  "calves": "Mollets",
  "chest/sternum": "Poitrine/Sternum",
  "fat loss": "Perte de graisse",
  "foot": "Pied",
  "forearms": "Avant-bras",
  "glutes": "Fessiers",
  "hamstrings": "Ischio-jambiers",
  "hips": "Hanches",
  "informational": "Informatif",
  "lateral abdominals (obliques)": "Abdominaux latéraux (obliques)",
  "lower back": "Bas du dos",
  "portion sizes": "Taille des portions",
  "psoas": "Psoas",
  "quads": "Quadriceps",
  "shoulder front": "Avant de l'épaule",
  "shoulder rear": "Arrière de l'épaule",
  "stretch": "Étirement",
  "thighs": "Cuisses",
  "tibia": "Tibia",
  "traps": "Trapèzes",
  "upper arms": "Haut des bras",
  "upper back": "Haut du dos",
  "water intake": "Hydratation",
  "wrists": "Poignets",
  "lifestyle": "Mode de vie",
  "nutrition": "Nutrition",
  "training": "Entraînement",
  "mobility phase": "Phase de mobilité",
  "stability phase": "Phase de stabilité",
  "strength phase": "Phase de force",
  "strengthening phase": "Phase de renforcement",
  "power phase": "Phase de puissance",
  "uncategorized": "Non classé",
  "active lifestyle": "Mode de vie actif",
  "additives": "Additifs",
  "carbohydrates": "Glucides",
  "clothing": "Vêtements",
  "dietary protein": "Protéines alimentaires",
  "fatty acids": "Acides gras",
  "general health & wellbeing": "Santé et bien-être en général",
  "healthy eating": "Alimentation saine",
  "healthy herbs": "Herbes bienfaisantes",
  "minerals": "Minéraux",
  "nutrition & fat loss": "Nutrition et perte de graisse",
  "organic compounds": "Composés organiques",
  "recipes": "Recettes",
  "vitamins": "Vitamines",
};

const NL = {
  "eating habits": "Eetgewoonten",
  "blood-pressure": "Bloeddruk",
  "blood-sugar": "Bloedsuiker",
  "brain health": "Hersengezondheid",
  "breathwork": "Ademhalingsoefeningen",
  "core stability": "Corestabiliteit",
  "digestive system": "Spijsvertering",
  "food intolerance": "Voedselintolerantie",
  "habits": "Gewoonten",
  "lower body": "Onderlichaam",
  "macro nutrients": "Macronutriënten",
  "micro nutrients": "Micronutriënten",
  "sleep": "Slaap",
  "stress management": "Stressmanagement",
  "upper body": "Bovenlichaam",
  "abdominals": "Buikspieren",
  "ankle": "Enkel",
  "calves": "Kuiten",
  "chest/sternum": "Borst/Borstbeen",
  "fat loss": "Vetverlies",
  "foot": "Voet",
  "forearms": "Onderarmen",
  "glutes": "Bilspieren",
  "hamstrings": "Hamstrings",
  "hips": "Heupen",
  "informational": "Informatief",
  "lateral abdominals (obliques)": "Schuine buikspieren (obliques)",
  "lower back": "Onderrug",
  "portion sizes": "Portiegroottes",
  "psoas": "Psoas",
  "quads": "Quadriceps",
  "shoulder front": "Voorkant schouder",
  "shoulder rear": "Achterkant schouder",
  "stretch": "Stretchen",
  "thighs": "Dijen",
  "tibia": "Scheenbeen",
  "traps": "Trapezius",
  "upper arms": "Bovenarmen",
  "upper back": "Bovenrug",
  "water intake": "Waterinname",
  "wrists": "Polsen",
  "lifestyle": "Levensstijl",
  "nutrition": "Voeding",
  "training": "Training",
  "mobility phase": "Mobiliteitsfase",
  "stability phase": "Stabiliteitsfase",
  "strength phase": "Krachtfase",
  "strengthening phase": "Versterkingsfase",
  "power phase": "Powerfase",
  "uncategorized": "Niet gecategoriseerd",
  "active lifestyle": "Actieve levensstijl",
  "additives": "Additieven",
  "carbohydrates": "Koolhydraten",
  "clothing": "Kleding",
  "dietary protein": "Voedingseiwitten",
  "fatty acids": "Vetzuren",
  "general health & wellbeing": "Algemene gezondheid en welzijn",
  "healthy eating": "Gezond eten",
  "healthy herbs": "Gezonde kruiden",
  "minerals": "Mineralen",
  "nutrition & fat loss": "Voeding en vetverlies",
  "organic compounds": "Organische verbindingen",
  "recipes": "Recepten",
  "vitamins": "Vitaminen",
};

export const dbLabel = (name, lng) => {
  if (!name) return name;
  const key = String(name).trim().toLowerCase();
  const map = lng === "fr" ? FR : lng === "nl" ? NL : null;
  return (map && map[key]) || String(name).trim();
};
